// File: frontend/src/utils/constants.js

// Person categories
export const PERSON_CATEGORIES = [
    { value: 'Person of Interest', label: 'Объект интереса' },
    { value: 'Client', label: 'Клиент' },
    { value: 'Witness', label: 'Свидетель' },
    { value: 'Victim', label: 'Потерпевший' },
    { value: 'Suspect', label: 'Подозреваемый' },
    { value: 'Other', label: 'Другое' },
  ];
  
  // Person statuses
  export const PERSON_STATUSES = [
    { value: 'Open', label: 'Открыто', color: 'green' },
    { value: 'Being Investigated', label: 'В расследовании', color: 'yellow' },
    { value: 'Closed', label: 'Закрыто', color: 'gray' },
    { value: 'On Hold', label: 'На паузе', color: 'blue' },
  ];
  
  // CRM Statuses - DYNAMIC (will be loaded from database)
  export let CRM_STATUSES = [
    { value: 'new_lead', label: 'Новый лид' },
    { value: 'attempted_engage', label: 'Попытка контакта' },
    { value: 'engaged', label: 'В контакте' },
    { value: 'qualified', label: 'Квалифицировано' },
    { value: 'follow_up', label: 'Повторный контакт' },
    { value: 'archived', label: 'В архиве' },
    { value: 'active', label: 'Активно' },
    { value: 'awaiting_response', label: 'Ожидает ответа' },
  ];
  
  // OSINT data types - DYNAMIC (will be loaded from database)
  export let OSINT_DATA_TYPES = [
    { value: 'Email', label: 'Email' },
    { value: 'Phone', label: 'Телефон' },
    { value: 'Social Media', label: 'Соцсети' },
    { value: 'Website', label: 'Сайт' },
    { value: 'Username', label: 'Имя пользователя' },
    { value: 'IP Address', label: 'IP-адрес' },
    { value: 'Vehicle', label: 'Транспорт' },
    { value: 'Financial', label: 'Финансы' },
    { value: 'Document ID', label: 'ID документа' },
    { value: 'Other', label: 'Другое' },
  ];
  
  // Connection types - DYNAMIC (will be loaded from database)
  export let CONNECTION_TYPES = [
    { value: 'associate', label: 'Связанный контакт' },
    { value: 'family', label: 'Семья' },
    { value: 'friend', label: 'Друг' },
    { value: 'enemy', label: 'Противник' },
    { value: 'employer', label: 'Работодатель/сотрудник' },
    { value: 'suspect', label: 'Связь с подозреваемым' },
    { value: 'witness', label: 'Свидетель' },
    { value: 'victim', label: 'Потерпевший' },
    { value: 'other', label: 'Другое' },
  ];
  
  // Location types
  export const LOCATION_TYPES = [
    { value: 'primary_residence', label: 'Основное место проживания' },
    { value: 'holiday_home', label: 'Дом отдыха' },
    { value: 'work', label: 'Работа' },
    { value: 'family_residence', label: 'Жилье семьи' },
    { value: 'favorite_hotel', label: 'Предпочитаемый отель' },
    { value: 'yacht_location', label: 'Локация яхты' },
    { value: 'other', label: 'Другое' },
  ];
  
  // Tool categories
  export const TOOL_CATEGORIES = [
    { value: 'Search Engines', label: 'Поисковые системы' },
    { value: 'Social Media', label: 'Соцсети' },
    { value: 'People Search', label: 'Поиск людей' },
    { value: 'Data Analysis', label: 'Анализ данных' },
    { value: 'Geolocation', label: 'Геолокация' },
    { value: 'Documentation', label: 'Документация' },
    { value: 'Other', label: 'Другое' },
  ];
  
  // Tool statuses
  export const TOOL_STATUSES = [
    { value: 'Active', label: 'Активно', color: 'green' },
    { value: 'Testing', label: 'Тестируется', color: 'yellow' },
    { value: 'Deprecated', label: 'Устарело', color: 'red' },
    { value: 'Offline', label: 'Недоступно', color: 'gray' },
  ];
  
  // Custom field types
  export const CUSTOM_FIELD_TYPES = [
    { value: 'text', label: 'Текст' },
    { value: 'textarea', label: 'Многострочный текст' },
    { value: 'select', label: 'Выпадающий список' },
    { value: 'date', label: 'Дата' },
  ];

// Travel purposes
export const TRAVEL_PURPOSES = [
  { value: 'business', label: 'Бизнес' },
  { value: 'vacation', label: 'Отпуск' },
  { value: 'family_visit', label: 'Визит к семье' },
  { value: 'medical', label: 'Медицина' },
  { value: 'education', label: 'Обучение' },
  { value: 'conference', label: 'Конференция' },
  { value: 'relocation', label: 'Переезд' },
  { value: 'transit', label: 'Транзит' },
  { value: 'unknown', label: 'Неизвестно' },
  { value: 'other', label: 'Другое' },
];

// Transportation modes
export const TRANSPORTATION_MODES = [
  { value: 'airplane', label: 'Самолет' },
  { value: 'train', label: 'Поезд' },
  { value: 'car', label: 'Автомобиль' },
  { value: 'bus', label: 'Автобус' },
  { value: 'ship', label: 'Корабль/круиз' },
  { value: 'private_jet', label: 'Частный самолет' },
  { value: 'helicopter', label: 'Вертолет' },
  { value: 'other', label: 'Другое' },
  { value: 'unknown', label: 'Неизвестно' },
];
  
  // Default app settings
  export const DEFAULT_APP_SETTINGS = {
    appName: 'Клиентская CRM',
    appLogo: null,
  };
  
  // Function to update dynamic constants from database
  export const updateDynamicConstants = (modelOptions) => {
    const connectionOptions = modelOptions
      .filter(opt => opt.model_type === 'connection_type' && opt.is_active)
      .sort((a, b) => a.display_order - b.display_order)
      .map(opt => ({ value: opt.option_value, label: opt.option_label }));
    
    if (connectionOptions.length > 0) {
      CONNECTION_TYPES = connectionOptions;
    }
  
    const crmStatuses = modelOptions
      .filter(opt => opt.model_type === 'crm_status' && opt.is_active)
      .sort((a, b) => a.display_order - b.display_order)
      .map(opt => ({ value: opt.option_value, label: opt.option_label }));
    
    if (crmStatuses.length > 0) {
      CRM_STATUSES = crmStatuses;
    }

    const osintDataTypes = modelOptions
      .filter(opt => opt.model_type === 'osint_data_type' && opt.is_active)
      .sort((a, b) => a.display_order - b.display_order)
      .map(opt => ({ value: opt.option_value, label: opt.option_label }));
    
    if (osintDataTypes.length > 0) {
      OSINT_DATA_TYPES = osintDataTypes;
    }
  };
